import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import 'moment-timezone';
import DateTimeModal from './DateTimeModal';
import './App.css';
import './SelfValidate.css';
import gpsIcon from "./img/gps.png";
import searchIcon from "./img/search-magnify.png";


export default class SelfValidate extends Component {
    constructor(props) {
        super(props);
        this.env = process.env.REACT_APP_ENVIRONMENT;
        this.urlParams = new URLSearchParams(window.location.search);
        this.handleChange = this.handleChange.bind(this);
        this.getCampaignInfo = this.getCampaignInfo.bind(this)
        this.getAvailableCouponCount = this.getAvailableCouponCount.bind(this)
        if (this.env === 'STAGING' && this.urlParams && this.urlParams.get('env') && this.urlParams.get('env') === 'dev') {
            this.baseUrl = process.env.REACT_APP_DEV_API_URL;
            this.stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY;
        } else {
            this.baseUrl = process.env.REACT_APP_API_URL;
            this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
        }
        this.hours = [];
        this.mins = [];
        this.fillHoursAndMinsOptions(0, 24);
        this.initialState = {
            availableCouponCount: null,
            loading: false,
            bookingDetail: null,
            errors: {},
            bookingStartTime: null,
            bookingEndTime: null,
            fields: {
                license_plate: ''
            }
        }
        this.state = this.initialState;
    }

    componentDidMount() {
        this.getArena()
    }

    getArena(){
        const urlParams = new URLSearchParams(window.location.search);
        fetch(`${this.baseUrl}/pay/arena/details?arena_hash=${urlParams.get('id')}`)
            .then(response => response.json())
            .then(resp => {
              if(resp.data && resp.status === "SUCCESS"){
                const data = resp.data;
                this.setState({ 
                  parking_id: data.parking_id,
                  name: data.name
                }, () => this.getCampaignInfo())
              }else{
                let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
                toast.dismiss();
                toast.error(errMsg);
              }
            })
            .catch((error) => {
              toast.dismiss();
              toast.error('Something went wrong');
            });
      }

    getCampaignInfo() {
        const urlParams = new URLSearchParams(window.location.search);
        const arenaHash = urlParams.get('id');
        const token = urlParams.get('campaign');
        fetch(`${this.baseUrl}/transient/booking/coupon?arena_name=${arenaHash}&token=${token}`)
            .then(response => response.json())
            .then(resp => {
                if (resp.data && resp.status === "SUCCESS") {
                    this.setState({
                        campaignInfo: resp.data[0].campaign_info,
                        timeZone: resp.data[0].timezone
                    })
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                    toast.dismiss();
                    toast.error(errMsg);
                }
            })
            .catch((error) => {
                toast.dismiss();
                toast.error('Something went wrong');
            });
    }

    resetState = () => {
        return {
          fields: {
            ...this.state.fields,
            license_plate: '',
          },
          couponRequired: '',
          isEntireValidation: false,
          bookingDetail: null,
          bookingStartTime: null,
          bookingEndTime: null,
          isValidated: false,
          isFreeValidate: false,
        }
      }

    getDetails = () => {
        if(!this.state.fields?.license_plate) return;
        this.setState({ loading: true });
        document.querySelector("input[name='license_plate']").blur();
        const { fields } = this.state;
        const vehicleNo = fields.license_plate ? fields.license_plate.toUpperCase().replace(/\s/g, "").replace(/\\/g, '') : '';
        fetch(`${this.baseUrl}/gated/booking/details?parking_id=${this.state.parking_id}&vehicle_no=${vehicleNo}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(async resp => {
                if (resp.data && resp.status === "SUCCESS") {
                    const data = resp.data[0];
                    const isGatedBookingPresent = data.gated_booking_present;
                    if(!isGatedBookingPresent){
                    this.setState({
                        bookingDetail: data,
                        showDateTimeModal: true,
                        hash: data.hash,
                        slotId: data.slot_id,
                        campaign_id: this.state.templateId,
                        vehicleNo: data.vehicle_no,
                        isGatedBookingPresent,
                        loading: false
                    });
                    return;
                    }
                    const { hours, mins, bookingStartTime, bookingEndTime } = this.getHoursAndMins(data);
                    this.setState({
                        bookingDetail: data,
                        parkingFee: data.parking_fee,
                        slotId: data.slot_id,
                        bookingStartTime,
                        bookingEndTime,
                        vehicleNo: data.vehicle_no,
                        isGatedBookingPresent,
                        fields: {
                            ...this.state.fields,
                            hours,
                            mins
                        }
                    }, async () => {
                        let entireValidationObj = await this.calculateIsEntireValidation();
                        this.setState({
                            isEntireValidation: entireValidationObj.isValid,
                            couponRequiredCount: entireValidationObj.couponRequired,
                            loading: false
                        });
                    })
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Cannot get booking start time';
                    toast.dismiss();
                    toast.error(errMsg);
                    this.setState({ loading: false });
                }
            })
            .catch((error) => {
                toast.dismiss();
                toast.error('Cannot get booking start time');
                this.setState({ loading: false });
            });
    }

    handleDateTimeModal = (value, resetLicensePlate) => {
        const resetState = resetLicensePlate ? this.resetState() : {};
        this.setState({
          showDateTimeModal: value,
          fields: {
            ...this.state.fields,
            license_plate: !value && resetLicensePlate ? '' : this.state.fields.license_plate
          },
          ...resetState
        });
    }


    fillHoursAndMinsOptions(hourStart, hourEnd, isOnlyHour) {
        this.hours = [];
        for (let i = hourStart; i <= hourEnd; i++) {
            this.hours.push({
                value: i,
                display: i + ' Hr'
            })
        }
        if (isOnlyHour) return;
        for (let j = 0; j < 60; j += 5) {
            if (j < 10) {
                this.mins.push({
                    value: j,
                    display: '0' + j + ' mins'
                })
            } else {
                this.mins.push({
                    value: j,
                    display: j + ' mins'
                })
            }
        }
    }

    async calculateIsEntireValidation(){
        let isValid = false;
        let couponRequired;
        let availableCouponCount;
        const {discount_per_booking, token_availability} = this.state.campaignInfo || {};
        if(token_availability) {
             availableCouponCount = await this.getAvailableCouponCount();
        }
        let totalParking =  this.state.parkingFee;
        if(!availableCouponCount || !discount_per_booking || !totalParking) return {isValid};
        couponRequired = Math.round(totalParking/discount_per_booking);
        if(couponRequired <= availableCouponCount){
          isValid = true;
        }
        return { isValid, couponRequired };
      }

      getAvailableCouponCount() {
        return fetch(`${this.baseUrl}/parking/campaign/coupons?campaign_id=${this.state.campaignInfo.campaign_id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data && data.status === "SUCCESS") {
                    this.setState({
                        availableCouponCount: data.data.available_coupon_count
                    })
                    return data.data.available_coupon_count;
                } else {
                    let errMsg = data.error && data.error.reason ? data.error.reason : 'Something went wrong';
                    toast.error(errMsg);
                    return null;
                }
            })
            .catch((error) => {
                let errMsg = error && error.reason ? error.reason : 'Something went wrong';
                toast.dismiss();
                toast.error(errMsg);
                return null;
            });
    }

    handleStartTimeForGated = (data, isStartTimeUpdated) => {
        const startTime = data.booking_start_time_str ? data.booking_start_time_str : moment().format('MMM DD, YYYY, hh:mm A');
        let endTime =  startTime ? moment(startTime, 'MMM DD, YYYY, hh:mm A').add(this.state.fields.hours, 'hours').format('MMM DD, YYYY, hh:mm A') : '';
        let dateTimeDiff, hours, mins;
        if((endTime && moment(endTime, 'MMM DD, YYYY, hh:mm A').isBefore(moment())) || isStartTimeUpdated){
          const currentTime = moment().format('MMM DD, YYYY, hh:mm A');
          dateTimeDiff = moment(currentTime, 'MMM DD, YYYY, hh:mm A').diff(startTime, 'hours', true);
          const duration = moment.duration(dateTimeDiff, 'hours');
          hours = Math.floor(duration.asHours());
          mins = Math.ceil(duration.minutes() / 5) * 5;
          if (mins >= 60) {
            hours += Math.floor(mins / 60);
            mins = mins % 60;
          }
          this.fillHoursAndMinsOptions(hours, 1440, true);
          endTime = moment(startTime, 'MMM DD, YYYY, hh:mm A').add(hours, 'hours').add(mins, 'minutes').format('MMM DD, YYYY, hh:mm A');
        }
        this.setState({
          bookingStartTime: startTime,
          bookingEndTime: endTime,
          isStartTimeForGatedCalled: startTime ? true : false,
          gatedDurationHrs: hours,
          gatedDurationMins: mins,
          showDateTimeModal: false,
          fields: {
            ...this.state.fields,
            ...{
              hours: hours >= 0 ? hours : this.state.fields.hours,
              mins: mins >= 0 ? mins : this.state.fields.mins
            }
          }
        }, () => {
          if(!startTime) toast.error('Cannot get booking start time');
          if(startTime) this.calculatePriceForDurationChange();
        })
      }

    calculatePriceForDurationChange() {
        this.setState({loading: true});
        const start = moment(this.state.bookingStartTime, 'MMM DD, YYYY, hh:mm A', this.state.timeZone).unix() * 1000;
        const end = moment(this.state.bookingEndTime, 'MMM DD, YYYY, hh:mm A', this.state.timeZone).unix() * 1000;
        const slotId = this.state.slotId;
        if (!start || !end || !slotId) return;
        fetch(`${this.baseUrl}/pay/parking/slot/details?start_date_time=${start}&end_date_time=${end}&parking_id=${this.state.parking_id}&slot_id=${slotId}`)
            .then((response) => response.json())
            .then((resp) => {
                if (resp.data && resp.status === "SUCCESS") {
                    let fields = this.state.fields;
                    fields = {
                        ...fields,
                        coupon: ''
                    }
                    this.setState({
                        parkingFee: resp.data.parking_fee
                    }, async () => {
                        let entireValidationObj = await this.calculateIsEntireValidation();
                        this.setState({
                            isEntireValidation: entireValidationObj.isValid,
                            couponRequiredCount: entireValidationObj.couponRequired,
                            loading: false
                        });
                    })
                } else {
                    let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
                    let fields = this.state.fields;
                    fields["coupon"] = '';
                    fields["spot_no"] = '';
                    this.setState({
                        fields,
                        parkingFee: null,
                        convenienceFee: null,
                        totalFee: null,
                        couponApplied: false,
                        discountAmount: 0,
                        isEntireValidation: false,
                        loading: false
                    }, () => {
                        toast.error(errMsg);
                    })
                }
            })
            .catch((error) => {
                let errMsg = error && error.reason ? error.reason : 'Something went wrong';
                this.setState({loading: false});
                toast.dismiss();
                toast.error(errMsg);
            });
    }
   handleChange(e) {
        let fields = { ...this?.state?.fields };
        const name = e.target.name;
        const value = e.target.value;
        fields[name] = value;
        const bookingDetail = this.state.bookingDetail && name == "license_plate" ? null : this.state.bookingDetail; 
        if (name === 'hours' || name === 'mins') {
            let selectedMins = name === 'mins' ? value : this.state.fields.mins;
            let selectedHours = name === 'hours' ? value : this.state.fields.hours;
            if (parseInt(selectedHours) === this.hours[0].value && parseInt(selectedMins) < this.state.gatedDurationMins) {
                this.props.notify(`The duration cannot be less than ${this.state.gatedDurationHrs}hr ${this.state.gatedDurationMins}min`, 'fail');
                return;
            }
            if(parseInt(selectedHours) === 24){
                fields["mins"] = 0;  
            }
            this.setState({
                fields,
                bookingDetail
            }, () => {
                this.setState({
                    bookingEndTime: moment(this.state.bookingStartTime, 'MMM DD, YYYY, hh:mm A').add(this.state.fields['hours'], 'hours').add(this.state.fields['mins'], 'minutes').format('MMM DD, YYYY, hh:mm A')
                }, async () => await this.calculatePriceForDurationChange());
            });
        } else {
            this.setState({
                fields,
                bookingDetail
            });
        }
    }

    getHoursAndMins(data) {
        const bookingStartTime = data.booking_start_time ? moment.unix(data.booking_start_time / 1000).tz(this.state.timeZone).format('MMM DD, YYYY, hh:mm A') : moment().format('MMM DD, YYYY, hh:mm A');
        // let bookingEndTime = bookingStartTime ? moment(bookingStartTime, 'MMM DD, YYYY, hh:mm A').add(1, 'hours').format('MMM DD, YYYY, hh:mm A') : '';
        let bookingEndTime = moment.tz(this.state.timeZone).format('MMM DD, YYYY, hh:mm A');
        let dateTimeDiff, hours, mins;
        if (false && bookingEndTime) {
            const currentTime = moment().format('MMM DD, YYYY, hh:mm A');
            dateTimeDiff = moment(currentTime, 'MMM DD, YYYY, hh:mm A').diff(bookingStartTime, 'hours', true);
            const duration = moment.duration(dateTimeDiff, 'hours');
            hours = Math.floor(duration.asHours());
            mins = Math.ceil(duration.minutes() / 5) * 5;
            if (mins >= 60) {
                hours += Math.floor(mins / 60);
                mins = mins % 60;
            }
            hours = hours > 24 ? 24 : hours;
            mins = hours == 24 ? 0 : mins;
            this.fillHoursAndMinsOptions(hours, 24, true);
            bookingEndTime = moment(bookingStartTime, 'MMM DD, YYYY, hh:mm A').add(hours, 'hours').add(mins, 'minutes').format('MMM DD, YYYY, hh:mm A');
        }
        return { hours, mins, bookingStartTime, bookingEndTime };
    }


    getNetParkingFee() {
        let netParkingFee = this.state.parkingFee;
        if (netParkingFee < 0) {
            netParkingFee = 0;
        }
        return netParkingFee;
    }

    handleSubmit(){
        this.setState({loading: true});
        const { campaign_id, fields, bookingStartTime, bookingEndTime } = this.state;
        const { id, parking_id, vehicle_no } = this.state.bookingDetail;
        const start_date_time = moment(bookingStartTime, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
        const end_date_time = moment(bookingEndTime, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
        const couponCount =  this.state.couponRequiredCount;
        if(couponCount > this.state.availableCouponCount){
            toast.error('Selected coupon count exceeds the available coupons', 'fail');
          return;
        }
        const request = {
          contact_no: "1111111111",
          country_code: "+1",
          campaign_id: this.state.campaignInfo.campaign_id,
          no_of_validation: couponCount,
          validation_reason: "",
          id: id ? id : 0,
          start_date_time,
          end_date_time,
          parking_id,
          vehicle_no,
          applied_at: "microsite",
        }
        fetch(`${this.baseUrl}/transient/booking/apply-coupon`, {
            method: 'post',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify(request)
           })
           .then(response => response.json())
           .then(resp => {
               if(resp.data && resp.status === "SUCCESS"){
                   this.setState({loading : false}, () =>  { 
                    toast.dismiss();
                    this.setState({
                        ...this.initialState
                    }, () => toast.success("Validate success"))
                })
             }else{
                this.setState({loading : false})
               toast.dismiss();
               toast.error('Something went wrong');
             }})
             .catch((error) => {
               this.setState({loading : false})
               toast.dismiss();
               toast.error('Something went wrong');
             });
       }


    render() {
        const { bookingDetail } = this.state;
        const netParkingFee = this.getNetParkingFee();
        return (
            <div style={{ position: 'relative' }} className='self-validate'>
                {(this.state.loading || this.state.isPaymentProcessing  || this.state.payErrorMsg || this.state.showErrorModal) && <div className='loader-background'></div>}
                {this.state.loading && <div className="loader-v2">
                    <div className='spinner'></div>
                    <p>Please do not refresh this page or press back button while we are processing the request</p>
                </div>}
                <div style={{textAlign: 'center', paddingBottom: 20}}>
                    <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
                </div>
                <div style={{textAlign: 'center'}} className="location">
                    <img style={{height: 35}} src={gpsIcon} /> 
                    <span>{this.state.name}</span>
                </div>
                <div className="upper" style={{ marginBottom: '10px', marginTop: '35px', position: 'relative' }}>
                    <span style={{fontSize: '15px'}} className="text-left" >License Plate <i>*</i></span>
                    <input
                        className="pay-fields"
                        value={this.state.fields["license_plate"]}
                        name="license_plate"
                        onChange={this.handleChange}
                        style={{ textTransform: 'uppercase' }}
                        onKeyDown={(e) => { if(e.key == 'Enter') this.getDetails()}}
                    />
                    {false && <img onClick={this.getDetails.bind(this)} style={{position: 'absolute', width: '35px', right: 5, top: 25, cursor: 'pointer'}} src={searchIcon} />}
                    <div className="error-msg"></div>
                </div>
                {!this.state.bookingDetail && <div style={{textAlign: 'center'}}>
                    <button onClick={this.getDetails.bind(this)} style={{ backgroundColor: '#dc6e7d', marginTop: '20px', width: '110px' }} className='svf-btn-pink coupon-validate-btn'>Get Details</button>
                </div>}
                {bookingDetail && (
                    <div style={{marginTop: '25px'}} className="booking-details">
                        <ul className="pay-timings">
                            <li>
                                <span className="list-initial">Start</span>
                                <span style={{cursor: !this.state.isGatedBookingPresent ? 'pointer' : 'default'}} onClick={() => !this.state.isGatedBookingPresent ? this.handleDateTimeModal(true) : ''}>{!this.state.isGatedBookingPresent && this.state.bookingStartTime ? this.state.bookingStartTime : bookingDetail.booking_start_time ? moment.unix(bookingDetail.booking_start_time/1000).tz(this.state.timeZone).format('MMM DD, YYYY, hh:mm A') : ''} {!this.state.isGatedBookingPresent && <button style={{cursor: 'pointer'}} type="button" className="start-time-edit-btn">Edit</button>}</span>
                            </li>
                            <li>
                                <span className="list-initial">End</span>
                                <span>{this.state.bookingEndTime ? this.state.bookingEndTime : ''}</span>
                            </li>
                            {/*<li>
                                <span className="list-initial">Duration</span>
                                <span>
                                    <select className='pq-select-line' name="hours" value={this.state.fields["hours"]} onChange={this.handleChange}>
                                        {this.hours.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                                    </select>
                                    <select className='pq-select-line' name="mins" value={this.state.fields["mins"]} onChange={this.handleChange} style={{ marginLeft: '10px' }}>
                                        {this.mins.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                                    </select>
                                </span>
                            </li>*/}
                            <li>
                                <span className="list-initial">Parking Fee</span>
                                <span style={{ color: '#dc6e7d', fontSize: '18px', fontWeight: 'bold' }}>{netParkingFee ? '$' + (netParkingFee / 100).toFixed(2) : '$0.00'}</span>
                            </li>
                        </ul>
                        {bookingDetail && <div style={{marginTop: '20px'}}>
                            {this.state.isEntireValidation && <div style={{textAlign: 'center'}}><button onClick={() => this.handleSubmit(true)} style={{ backgroundColor: '#dc6e7d', marginTop: '20px', width: '170px' }} className='svf-btn-pink coupon-validate-btn'>{`Validate (${this.state.couponRequiredCount})`}</button></div>}
                            {!this.state.isEntireValidation && <div style={{ marginTop: '25px', color: 'red' }}><h5>Do not have enough coupons to validate this</h5></div>}
                        </div>}
                    </div>
                )}
                {this.state.showDateTimeModal && <DateTimeModal  submit={this.handleStartTimeForGated} start={this.state.start} close={this.handleDateTimeModal} />}
                <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
            </div>
        )
    }
}
